import React from 'react'
import Button from '@mui/joy/Button'
import Box from '@mui/joy/Box'
import Skeleton from '@mui/joy/Skeleton'
import Typography from '@mui/joy/Typography'
import { useTranslation } from 'react-i18next'

export default function GarageCardSkeleton() {

    const { t } = useTranslation()

    return (
        <Box sx={{
                display: 'flex',
                bgcolor: 'white',
                borderRadius: '5px',
                border: '1px solid var(--joy-palette-neutral-200)',
                overflow: 'hidden',
                boxShadow: `var(--joy-shadowRing, 0 0 #000),
                    0.3px 0.8px 1.1px rgba(187 187 187 / 0.11),
                    0.5px 1.3px 1.8px -0.6px rgba(187 187 187 / 0.18),
                    1.1px 2.7px 3.8px -1.2px rgba(187 187 187 / 0.26)`,
                fontFamily: 'var(--joy-fontFamily-body)'
         }}>
            <Box sx={{
                flex: '0 0 35%',
                backgroundColor: '#CDD7E1'
            }}>
            </Box>
            <Box
                sx={{
                    padding: {
                        xs: '0.65rem',
                        lg: '0.75rem',
                    },
                    flexGrow: 1,
                }}
            >
                <Box display="flex" justifyContent="space-between">
                    <Typography sx={{
                        paddingRight: '0.5rem',
                        fontWeight: 600,
                        fontSize: {
                            xs: '0.875rem',
                            sm: '1rem',
                        },
                    }}>
                        <Skeleton animation="wave">
                            Name placeholder
                        </Skeleton>
                    </Typography>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: {
                            xs: '0.875rem',
                            sm: '1rem',
                        },
                    }}>
                        <Skeleton animation="wave">
                            --- Kč
                        </Skeleton>
                    </Typography>
                </Box>
                <Box display="flex" justifyContent="flex-end">
                    <Typography level="body-sm" mb={0.5} sx={{
                        fontSize: {
                            xs: '0.75rem',
                            sm: '0.875rem',
                        },
                    }}>
                        <Skeleton animation="wave">
                            -- Kč/hod
                        </Skeleton>
                    </Typography>
                </Box>
                <Box display="flex" justifyContent="flex-end" mt={0.5} flexGrow={1}>
                    <Box display="flex" flexDirection="column" justifyContent="flex-end">
                        <Button size='sm' disabled sx={{
                            "&:disabled": {
                                backgroundColor: '#FFC400',
                                color: '#FFC400',
                                opacity: 1,
                            },
                        }}>{t('general.bookNow')}</Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}